window.theme = window.theme || {};

theme.Cart = (function () {
    var selectors = {
        cartCount: '[data-cart-count]',
        cartCountBubble: '[data-cart-count-bubble]',
        cartDiscount: '[data-cart-discount]',
        cartDiscountTitle: '[data-cart-discount-title]',
        cartDiscountAmount: '[data-cart-discount-amount]',
        cartDiscountWrapper: '[data-cart-discount-wrapper]',
        cartErrorMessage: '[data-cart-error-message]',
        cartErrorMessageWrapper: '[data-cart-error-message-wrapper]',
        cartItem: '[data-cart-item]',
        cartHeckwischerCrosssell: '[cart-heckwischer-crosssell]',
        cartItemDetails: '[data-cart-item-details]',
        cartItemDiscount: '[data-cart-item-discount]',
        cartItemDiscountedPriceGroup: '[data-cart-item-discounted-price-group]',
        cartItemDiscountTitle: '[data-cart-item-discount-title]',
        cartItemDiscountAmount: '[data-cart-item-discount-amount]',
        cartItemDiscountList: '[data-cart-item-discount-list]',
        cartItemFinalPrice: '[data-cart-item-final-price]',
        cartItemImage: '[data-cart-item-image]',
        cartItemLinePrice: '[data-cart-item-line-price]',
        cartItemOriginalPrice: '[data-cart-item-original-price]',
        cartItemPrice: '[data-cart-item-price]',
        cartItemPriceList: '[data-cart-item-price-list]',
        cartItemProperty: '[data-cart-item-property]',
        cartItemPropertyName: '[data-cart-item-property-name]',
        cartItemPropertyValue: '[data-cart-item-property-value]',
        cartItemRegularPriceGroup: '[data-cart-item-regular-price-group]',
        cartItemComparePrice: '[data-cart-item-compare-price]',
        cartItemComparePriceLine: '[data-cart-item-compare-price-line]',
        cartItemRegularPrice: '[data-cart-item-regular-price]',
        /*cartItemWiperLength:'[data-cart-item-wiper-length]',*/
        cartItemShippingTime: '[data-cart-item-shipping-time]',
        /*cartItemShippingIcon:'[data-cart-item-shipping-icon] > svg > path',*/
        cartItemTitle: '[data-cart-item-title]',
        cartItemOption: '[data-cart-item-option]',
        cartLineItems: '[data-cart-line-items]',
        cartNote: '[data-cart-notes]',
        cartQuantityErrorMessage: '[data-cart-quantity-error-message]',
        cartQuantityErrorMessageWrapper: '[data-cart-quantity-error-message-wrapper]',
        cartRemove: '[data-cart-remove]',
        cartStatus: '[data-cart-status]',
        cartSubtotal: '[data-cart-subtotal]',
        cartShippingCosts: '[data-cart-shipping-costs]',
        cartTotalSavings: '[data-cart-total-savings]',
        cartTotalOrderPrice: '[data-cart-total-order-price]',
        cartTableCell: '[data-cart-table-cell]',
        cartWrapper: '[data-cart-wrapper]',
        emptyPageContent: '[data-empty-page-content]',
        quantityInput: '[data-quantity-input]',
        quantityInputMobile: '[data-quantity-input-mobile]',
        quantityInputDesktop: '[data-quantity-input-desktop]',
        quantityLabelMobile: '[data-quantity-label-mobile]',
        quantityLabelDesktop: '[data-quantity-label-desktop]',
        inputQty: '[data-quantity-input]',
        inputChange: '[data-quantity-change]',
        thumbnails: '.cart__image',
        unitPrice: '[data-unit-price]',
        unitPriceBaseUnit: '[data-unit-price-base-unit]',
        unitPriceGroup: '[data-unit-price-group]'
    };

    var classes = {
        cartNoCookies: 'cart--no-cookies',
        cartRemovedProduct: 'cart__removed-product',
        hide: 'hide',
        inputError: 'input--error'
    };

    var attributes = {
        cartItemIndex: 'data-cart-item-index',
        cartItemKey: 'data-cart-item-key',
        cartItemQuantity: 'data-cart-item-quantity',
        cartItemTitle: 'data-cart-item-title',
        cartItemUrl: 'data-cart-item-url',
        quantityItem: 'data-quantity-item'
    };

    var CompPricesArray = new Array;
    var bRemoved = false;
    var removedItemIndex = 0;

    theme.breakpoints = theme.breakpoints || {};

    if (
        isNaN(theme.breakpoints.medium) ||
        theme.breakpoints.medium === undefined
    ) {
        theme.breakpoints.medium = 750;
    }

    var mediumUpQuery = '(min-width: ' + theme.breakpoints.medium + 'px)';

    function Cart(container) {
        this.$container = $(container);
        this.$thumbnails = $(selectors.thumbnails, this.$container);
        this.ajaxEnabled = this.$container.data('ajax-enabled');

        if (!this.cookiesEnabled()) {
            this.$container.addClass(classes.cartNoCookies);
        }

        this.$thumbnails.css('cursor', 'pointer');
        this.$container.on(
            'click',
            selectors.thumbnails,
            this._handleThumbnailClick
        );

        this.$container.on(
            'change',
            selectors.inputQty,
            $.debounce(500, this._handleInputQty.bind(this))
        );

        this.$container.on(
            'click',
            selectors.inputChange,
            $.debounce(500, this._handleInputQtyChange.bind(this))
        );

        this.mql = window.matchMedia(mediumUpQuery);
        this.mql.addListener(this.setQuantityFormControllers.bind(this));
        this.setQuantityFormControllers();

        if (this.ajaxEnabled) {
            /**
             * Because the entire cart is recreated when a cart item is updated,
             * we cannot cache the elements in the cart. Instead, we add the event
             * listeners on the cart's container to allow us to retain the event
             * listeners after rebuilding the cart when an item is updated.
             */

            this.$container.on(
                'change',
                selectors.cartNote,
                this._onNoteChange.bind(this)
            );

            this.$container.on(
                'click',
                selectors.cartRemove,
                this._onRemoveItem.bind(this)
            );

            this._setupCartTemplates();
        }
    }

    Cart.prototype = _.assignIn({}, Cart.prototype, {
        _setupCartTemplates: function () {

            //Check which Item is in Cart and setup item templates
            this.$itemTemplate = $(selectors.cartItem, this.$container)
                .first()
                .clone();

            this.$itemTemplateNoCompare = $('[data-cart-item-no-compare]', this.$container).first();
            if (this.$itemTemplateNoCompare.length === 0) {
                this.$itemTemplateNoCompare = this.$itemTemplate.clone();
            } else {
                this.$itemTemplateNoCompare = this.$itemTemplateNoCompare.clone();
            }

            this.$cartHeckwischerCrosssell = $('[cart-heckwischer-crosssell]', this.$container).first().clone();

            this.$itemTemplateCompare = $('[data-cart-item-compare]', this.$container).first();
            if (this.$itemTemplateCompare.length === 0) {
                this.$itemTemplateCompare = this.$itemTemplate.clone();
            } else {
                this.$itemTemplateCompare = this.$itemTemplateCompare.clone();
            }

            //Get Cart Item Discount Template (IRRELEVANT)
            this.$itemDiscountTemplate = $(
                selectors.cartItemDiscount,
                this.$itemTemplate
            ).clone();

            //Get Item Option Template (NO FURTHER INVESTIGATION)
            this.$itemOptionTemplate = $(
                selectors.cartItemOption,
                this.$container
            ).first().clone();

            //Get Item Property Template (NO FURTHER INVESTIGATION)
            this.$itemPropertyTemplate = $(
                selectors.cartItemProperty,
                this.$container
            ).first().clone();

            //Get Single Item Price Template (STANDARD)
            this.$itemPriceListTemplate = $(
                selectors.cartItemPriceList,
                this.$itemTemplate
            ).clone();

            //Get Final Item Line Price Template (STANDARD)
            this.$itemLinePriceTemplate = $(
                selectors.cartItemLinePrice,
                this.$itemTemplate
            ).clone();

            //Get Single Item Price Compare Template
            this.$itemPriceListTemplateCompare = $(
                selectors.cartItemPriceList,
                this.$itemTemplateCompare
            ).clone();

            //Get Final Item Line Price Compare Template
            this.$itemLinePriceTemplateCompare = $(
                selectors.cartItemLinePrice,
                this.$itemTemplateCompare
            ).clone();

            //Get Single Item Price No Compare Template
            this.$itemPriceListTemplateNoCompare = $(
                selectors.cartItemPriceList,
                this.$itemTemplateNoCompare
            ).clone();

            //Get Final Item Line Price No Compare Template
            this.$itemLinePriceTemplateNoCompare = $(
                selectors.cartItemLinePrice,
                this.$itemTemplateNoCompare
            ).clone();

            //Get Cart Discount Template (IRRELEVANT)
            this.$cartDiscountTemplate = $(
                selectors.cartDiscount,
                this.$container
            ).clone();
        },

        _handleInputQtyChange: function (evt) {
            var changeelement = $(evt.currentTarget);
            if (changeelement[0].classList.contains("quantity-plus")) {
                var $input = $(evt.currentTarget.previousElementSibling);
                var newValue = parseInt($input.val()) + 1;
            } else {
                var $input = $(evt.currentTarget.nextElementSibling);
                var oldValue = parseInt($input.val());
                if (oldValue > 1) {
                    var newValue = oldValue - 1;
                } else {
                    var newValue = 1;
                }
            }
            var itemIndex = $input.data('quantity-item');
            var $itemElement = $input.closest(selectors.cartItem);
            var $itemQtyInputs = $('[data-quantity-item=' + itemIndex + ']');
            var isValidValue = !(newValue < 0 || isNaN(newValue));
            $itemQtyInputs.val(newValue);

            this._hideCartError();
            this._hideQuantityErrorMessage();

            if (!isValidValue) {
                this._showQuantityErrorMessages($itemElement);
                return;
            }

            if (isValidValue && this.ajaxEnabled) {
                this._updateItemQuantity(
                    itemIndex,
                    $itemElement,
                    $itemQtyInputs,
                    newValue
                );
            }
        },

        _handleInputQty: function (evt) {
            var $input = $(evt.target);
            var itemIndex = $input.data('quantity-item');
            var $itemElement = $input.closest(selectors.cartItem);
            var $itemQtyInputs = $('[data-quantity-item=' + itemIndex + ']');
            var value = parseInt($input.val());
            var isValidValue = !(value < 0 || isNaN(value));
            $itemQtyInputs.val(value);

            this._hideCartError();
            this._hideQuantityErrorMessage();

            if (!isValidValue) {
                this._showQuantityErrorMessages($itemElement);
                return;
            }

            if (isValidValue && this.ajaxEnabled) {
                this._updateItemQuantity(
                    itemIndex,
                    $itemElement,
                    $itemQtyInputs,
                    value
                );
            }
        },

        _updateItemQuantity: function (
            itemIndex,
            $itemElement,
            $itemQtyInputs,
            value
        ) {
            var key = $itemElement.attr(attributes.cartItemKey);
            var index = $itemElement.attr(attributes.cartItemIndex);

            if (value == 0) {
                removedItemIndex = index;
                bRemoved = true;
            }


            var params = {
                url: '/cart/change.js',
                data: { quantity: value, line: index },
                dataType: 'json'
            };

            $.post(params)
                .done(
                    function (state) {
                        if (state.item_count === 0) {
                            this._emptyCart();
                        } else {
                            this._createCart(state);
                            this._updateCartUpsellCarousel(state);
                            if (value === 0) {
                                this._showRemoveMessage($itemElement.clone());
                            } else {
                                var $lineItem = $('[data-cart-item-key="' + key + '"]');
                                var item = this.getItem(key, state);

                                //$(selectors.quantityInput, $lineItem).focus();
                                this._updateLiveRegion(item);
                            }
                        }

                        this._setCartCountBubble(state.item_count);
                    }.bind(this)
                )
                .fail(
                    function () {
                        this._showCartError($itemQtyInputs);
                    }.bind(this)
                );
        },

        getItem: function (key, state) {
            return state.items.find(function (item) {
                return item.key === key;
            });
        },

        _liveRegionText: function (item) {
            // Dummy content for live region
            var liveRegionText =
                theme.strings.update +
                ': [QuantityLabel]: [Quantity], [Regular] [$$] [DiscountedPrice] [$]. [PriceInformation]';

            // Update Quantity
            liveRegionText = liveRegionText
                .replace('[QuantityLabel]', theme.strings.quantity)
                .replace('[Quantity]', item.quantity);

            // Update pricing information
            var regularLabel = '';
            var regularPrice = theme.Currency.formatMoney(
                item.original_line_price,
                theme.moneyFormat
            );
            var discountLabel = '';
            var discountPrice = '';
            var discountInformation = '';

            if (item.original_line_price > item.final_line_price) {
                regularLabel = theme.strings.regularTotal;

                discountLabel = theme.strings.discountedTotal;
                discountPrice = theme.Currency.formatMoney(
                    item.final_line_price,
                    theme.moneyFormat
                );

                discountInformation = theme.strings.priceColumn;
            }

            liveRegionText = liveRegionText
                .replace('[Regular]', regularLabel)
                .replace('[$$]', regularPrice)
                .replace('[DiscountedPrice]', discountLabel)
                .replace('[$]', discountPrice)
                .replace('[PriceInformation]', discountInformation)
                .trim();

            return liveRegionText;
        },

        _updateLiveRegion: function (item) {
            var $liveRegion = $(selectors.cartStatus);
            $liveRegion.html(this._liveRegionText(item)).attr('aria-hidden', false);

            // hide content from accessibility tree after announcement
            setTimeout(function () {
                $liveRegion.attr('aria-hidden', true);
            }, 1000);
        },

        _updateProgressBar: function (cart_price) {
            let progressbar_outer = $('.progress-bar-container')[0];
            let progress_divideby = theme.freeshipping_threshold / 100;
            var left_for_free_shipping = theme.freeshipping_threshold - cart_price;
            var progress_percent = Math.round(cart_price / progress_divideby);
            if (progress_percent >= 100) {
                progress_percent = 100;
                $(progressbar_outer).addClass('progress-full');
            } else {
                $(progressbar_outer).removeClass('progress-full');
            }
            var progressbar_text = $('[data-cart-progressbar-text]')[0];
            var progressbar_inner = $('[data-cart-progressbar-progress]')[0];

            if (left_for_free_shipping > 0) {
                $(progressbar_text, this.$container).html(
                    "<p>Nur noch <strong class='pg_color'>" + theme.Currency.formatMoney(left_for_free_shipping, theme.moneyFormatWithCurrency) + "</strong> bis zum <strong>kostenfreien</strong> Versand.</p>"
                );
            } else {
                $(progressbar_text, this.$container).html(
                    "<p>Glückwunsch! Wir versenden deine Bestellung <strong>versandkostenfrei</strong>.</p>"
                );
            }

            $(progressbar_inner, this.$container).html(
                "<div class='progress-bar-inner' style='width:" + progress_percent + "%'>" + progress_percent + "%</div>"
            );


            //console.log(element.innerHTML);

        },

        _updateCartUpsellCarousel: function (state) {
            let cartTotal = state.total_price;
            let threshold = theme.freeshipping_threshold;

            // 1. Selektiere den Container
            const carousel = document.querySelector('.cart-upsell-carousel-slider');

            // Prüfen, ob das Karussell überhaupt auf der Seite existiert
            if (!carousel) return;

            // 2. Selektiere alle Slides
            const slides = carousel.querySelectorAll('.swiper-slide');

            // Prüfen, ob Slides vorhanden sind
            if (slides.length > 0) {
                slides.forEach(slide => {
                    // Preis des Upsell-Produkts aus dem Data-Attribut holen (ebenfalls in Cents laut Markup)
                    const productPrice = parseInt(slide.getAttribute('data-cart-upsell-product-price')) || 0;
                    const nudgeTag = slide.querySelector('.shipping-nudge-tag');
                    if (nudgeTag) {
                        if ((cartTotal + productPrice) > threshold && cartTotal < theme.freeshipping_threshold) {
                            nudgeTag.classList.remove('hidden');
                        } else {
                            nudgeTag.classList.add('hidden');
                        }
                    }
                });
            }
        },

        _createCart: function (state) {
            var cartDiscountList = this._createCartDiscountList(state);
            CompPricesArray = [];

            $(selectors.cartLineItems, this.$container).html(
                this._createLineItemList(state)
            );
            bRemoved = false;

            this.setQuantityFormControllers();

            $(selectors.cartNote, this.$container).val(state.note);

            if (cartDiscountList.length === 0) {
                $(selectors.cartDiscountWrapper, this.$container)
                    .html('')
                    .addClass(classes.hide);
            } else {
                $(selectors.cartDiscountWrapper, this.$container)
                    .html(cartDiscountList)
                    .removeClass(classes.hide);
            }
            if(theme.freeshipping_threshold){
                this._updateProgressBar(state.total_price);
            }
            

            $(selectors.cartSubtotal, this.$container).html(
                theme.Currency.formatMoney(
                    state.total_price,
                    theme.moneyFormatWithCurrency
                )
            );

            //Define Shipping Costs
            var shippingcosts = 0;
            if (!theme.freeshipping_threshold) {
                shippingcosts = theme.shipping_normal;
            }
            if (state.total_price >= 1500 && state.total_price < theme.freeshipping_threshold) {
                shippingcosts = theme.shipping_normal;
            }
            if (state.total_price < 1500) {
                shippingcosts = theme.shipping_expensive;
            }

            //Total Savings relativ UVP
            var total_savings = this._calculateSavings(state.total_price);

            $(selectors.cartTotalSavings, this.$container).html(
                theme.Currency.formatMoney(
                    total_savings,
                    theme.moneyFormatWithCurrency
                )
            );

            $(selectors.cartShippingCosts, this.$container).html(
                theme.Currency.formatMoney(
                    shippingcosts,
                    theme.moneyFormatWithCurrency
                )
            );

            //Total Order Price including Shipping
            var total_order_price = state.total_price + shippingcosts;

            $(selectors.cartTotalOrderPrice, this.$container).html(
                theme.Currency.formatMoney(
                    total_order_price,
                    theme.moneyFormatWithCurrency
                )
            );
        },

        _createCartDiscountList: function (cart) {
            return $.map(
                cart.cart_level_discount_applications,
                function (discount) {
                    var $discount = this.$cartDiscountTemplate.clone();
                    $discount.find(selectors.cartDiscountTitle).text(discount.title);
                    $discount
                        .find(selectors.cartDiscountAmount)
                        .html(
                            theme.Currency.formatMoney(
                                discount.total_allocated_amount,
                                theme.moneyFormat
                            )
                        );
                    return $discount[0];
                }.bind(this)
            );
        },

        _getComparePrice: function (index) {
            var compPrices = $(selectors.cartItemComparePrice); //select all Comp Prices of all items

            if (bRemoved) {
                compPrices.splice(removedItemIndex - 1, 1);
            }

            var tmpNumber = compPrices[index].innerText.replace(" €", "");
            var cmpPrice = parseInt(tmpNumber.replace(",", ""));
            return cmpPrice;
        },

        /*_getWiperLength: function(index) {
          var wiperlength = $(selectors.cartItemWiperLength); //select all Wiper Length of all items
          if(bRemoved){
                wiperlength.splice(removedItemIndex - 1,1);
          }
          return wiperlength;
        },*/

        _getShippingTime: function (index) {
            var shippingtime = $(selectors.cartItemShippingTime); //select all Wiper Length of all items
            if (bRemoved) {
                shippingtime.splice(removedItemIndex - 1, 1);
            }
            return shippingtime;
        },
        _getShippingIcon: function (index) {
            var shippingicon = $(selectors.cartItemShippingIcon); //select all Wiper Length of all items
            if (bRemoved) {
                shippingicon.splice(removedItemIndex - 1, 1);
            }
            return shippingicon;
        },

        _calculateSavings: function (cart_total) {
            var uvp_total = 0;
            for (var c = 0; c < CompPricesArray.length; c++) {
                uvp_total += CompPricesArray[c];
            }
            var savings_total = uvp_total - cart_total;
            return savings_total;
        },

        _createLineItemList: function (state) {

            let lineItems = $.map(
                state.items,
                function (item, index) {
                    //console.log(item);
                    var cmpPrice = this._getComparePrice(index);
                    item.comparePrice = cmpPrice;

                    var originalPriceTemplate = null;
                    if (cmpPrice > item.price) {
                        this.$itemLinePriceTemplate = this.$itemLinePriceTemplateCompare.clone();
                        //this.$itemPriceListTemplate = this.$itemPriceListTemplateCompare.clone();
                        var $item = this.$itemTemplateCompare.clone();
                        var $itemPriceList = this.$itemPriceListTemplateCompare.clone();
                        originalPriceTemplate = this.$itemPriceListTemplateCompare;
                    } else {
                        this.$itemLinePriceTemplate = this.$itemLinePriceTemplateNoCompare.clone();
                        //this.$itemPriceListTemplate = this.$itemPriceListTemplateNoCompare.clone();
                        var $item = this.$itemTemplateNoCompare.clone();
                        var $itemPriceList = this.$itemPriceListTemplateNoCompare.clone();
                        originalPriceTemplate = this.$itemPriceListTemplateNoCompare;
                    }
                    //var $item = this.$itemTemplate.clone();
                    //var $itemPriceList = this.$itemPriceListTemplate.clone();

                    this._setLineItemAttributes($item, item, index);
                    this._setLineItemImage($item, item.featured_image);

                    /*item.wiperLength = this._getWiperLength(index);*/
                    item.shippingtime = this._getShippingTime(index);
                    /*item.icon_shipping = this._getShippingIcon(index);*/

                    //Styling of Shipping Time Message
                    if (item.shippingtime[index].innerText.includes("6")) {
                        $(selectors.cartItemShippingTime, $item)
                            .css("color", "orange");
                        /*
                        $(selectors.cartItemShippingIcon,$item)
                         .css("fill", "orange");*/
                    } else {
                        $(selectors.cartItemShippingTime, $item)
                            .css("color", "#348553");
                        /*
                        $(selectors.cartItemShippingIcon,$item)
                         .css("fill", "#348553");*/
                    }
                    /*
                    $(selectors.cartItemWiperLength,$item)
                          .text(item.wiperLength[index].innerText);
                    */

                    $(selectors.cartItemShippingTime, $item)
                        .text(item.shippingtime[index].innerText);

                    CompPricesArray[index] = item.comparePrice * item.quantity;

                    $(selectors.cartItemTitle, $item)
                        .text(item.product_title)
                        .attr('href', item.url);

                    var productDetailsList = this._createProductDetailsList(
                        item.product_has_only_default_variant,
                        item.options_with_values,
                        item.properties
                    );
                    this._setProductDetailsList($item, productDetailsList);

                    this._setItemRemove($item, item.title);

                    $itemPriceList.html(
                        this._createItemPriceSingle(
                            item.comparePrice,
                            item.original_price,
                            item.final_price,
                            originalPriceTemplate
                        )
                    );

                    if (item.unit_price_measurement) {
                        $itemPriceList.append(
                            this._createUnitPrice(
                                item.unit_price,
                                item.unit_price_measurement,
                                originalPriceTemplate
                            )
                        );
                    }

                    this._setItemPrice($item, $itemPriceList);

                    var itemDiscountList = this._createItemDiscountList(item);
                    this._setItemDiscountList($item, itemDiscountList);

                    this._setQuantityInputs($item, item, index);


                    var itemLinePrice = this._createItemPriceLine(
                        item.comparePrice * item.quantity,
                        item.original_line_price,
                        item.final_line_price,
                        this.$itemLinePriceTemplate
                    );
                    this._setItemLinePrice($item, itemLinePrice);



                    return $item[0];
                }.bind(this)
            );

            // 2. Heckwischer Cross-Sell TR am Ende hinzufügen
            if (this.$cartHeckwischerCrosssell && this.$cartHeckwischerCrosssell.length) {
                var $crossSell = this.$cartHeckwischerCrosssell.clone();

                // WICHTIG: Event-Listener neu binden, da .clone() Events nicht mitnimmt
                $crossSell.find('#heck-cart-button').on('click', function () {
                    const heck_form = document.getElementById("cross-sell-heck");
                    if (heck_form) heck_form.submit();
                });


                lineItems.push($crossSell[0]);
            }
            //console.log(state);

            // 3. Das komplette Array (Produkte + Cross-Sell) zurückgeben
            return lineItems;
        },


        _setLineItemAttributes: function ($item, item, index) {
            $item
                .attr(attributes.cartItemKey, item.key)
                .attr(attributes.cartItemUrl, item.url)
                .attr(attributes.cartItemTitle, item.title)
                .attr(attributes.cartItemIndex, index + 1)
                .attr(attributes.cartItemQuantity, item.quantity);
        },

        _setLineItemImage: function ($item, featuredImage) {
            var $image = $(selectors.cartItemImage, $item);

            var sizedImageUrl =
                featuredImage.url !== null
                    ? theme.Images.getSizedImageUrl(featuredImage.url, 'x190')
                    : null;

            if (sizedImageUrl) {
                $image
                    .attr('alt', featuredImage.alt)
                    .attr('src', sizedImageUrl)
                    .removeClass(classes.hide);
            } else {
                $image.remove();
            }
        },

        _setProductDetailsList: function ($item, productDetailsList) {
            var $itemDetails = $(selectors.cartItemDetails, $item);

            if (productDetailsList.length === 0) {
                $itemDetails.addClass(classes.hide).text('');
            } else {
                $itemDetails.removeClass(classes.hide).html(productDetailsList);
            }
        },

        _setItemPrice: function ($item, price) {
            $(selectors.cartItemPrice, $item).html(price);
        },

        _setItemDiscountList: function ($item, discountList) {
            var $itemDiscountList = $(selectors.cartItemDiscountList, $item);

            if (discountList.length === 0) {
                $itemDiscountList.html('').addClass(classes.hide);
            } else {
                $itemDiscountList.html(discountList).removeClass(classes.hide);
            }
        },

        _setItemRemove: function ($item, title) {
            $(selectors.cartRemove, $item).attr(
                'aria-label',
                theme.strings.removeLabel.replace('[product]', title)
            );
        },

        _setQuantityInputs: function ($item, item, index) {
            $(selectors.quantityInputMobile, $item)
                .attr('id', 'updates_' + item.key)
                .attr(attributes.quantityItem, index + 1)
                .val(item.quantity);

            $(selectors.quantityInputDesktop, $item)
                .attr('id', 'updates_large_' + item.key)
                .attr(attributes.quantityItem, index + 1)
                .val(item.quantity);

            $(selectors.quantityLabelMobile, $item).attr(
                'for',
                'updates_' + item.key
            );

            $(selectors.quantityLabelDesktop, $item).attr(
                'for',
                'updates_large_' + item.key
            );
        },

        setQuantityFormControllers: function () {
            if (this.mql.matches) {
                $(selectors.quantityInputDesktop).attr('name', 'updates[]');
                $(selectors.quantityInputMobile).removeAttr('name');
            } else {
                $(selectors.quantityInputMobile).attr('name', 'updates[]');
                $(selectors.quantityInputDesktop).removeAttr('name');
            }
        },

        _setItemLinePrice: function ($item, price) {
            $(selectors.cartItemLinePrice, $item).html(price);
        },

        _createProductDetailsList: function (
            product_has_only_default_variant,
            options,
            properties
        ) {
            var optionsPropertiesHTML = [];

            if (!product_has_only_default_variant) {
                optionsPropertiesHTML = optionsPropertiesHTML.concat(
                    this._getOptionList(options)
                );
            }

            if (properties !== null && Object.keys(properties).length !== 0) {
                optionsPropertiesHTML = optionsPropertiesHTML.concat(
                    this._getPropertyList(properties)
                );
            }

            return optionsPropertiesHTML;
        },

        _getOptionList: function (options) {
            return $.map(
                options,
                function (option) {
                    var $optionElement = this.$itemOptionTemplate.clone();

                    $optionElement
                        .html('<strong>' + option.name + '</strong>' + ': ' + option.value)
                        .removeClass(classes.hide);

                    return $optionElement[0];
                }.bind(this)
            );
        },

        _getPropertyList: function (properties) {
            var propertiesArray =
                properties !== null ? Object.entries(properties) : [];

            return $.map(
                propertiesArray,
                function (property) {
                    var $propertyElement = this.$itemPropertyTemplate.clone();

                    // Line item properties prefixed with an underscore are not to be displayed
                    if (property[0].charAt(0) === '_') return;

                    // if the property value has a length of 0 (empty), don't display it
                    if (property[1].length === 0) return;

                    $propertyElement
                        .find(selectors.cartItemPropertyName)
                        .text(property[0]);

                    if (property[0].indexOf('/uploads/') === -1) {
                        $propertyElement
                            .find(selectors.cartItemPropertyValue)
                            .text(': ' + property[1]);
                    } else {
                        $propertyElement
                            .find(selectors.cartItemPropertyValue)
                            .html(
                                ': <a href="' +
                                property[1] +
                                '"> ' +
                                property[1].split('/').pop() +
                                '</a>'
                            );
                    }

                    $propertyElement.removeClass(classes.hide);

                    return $propertyElement[0];
                }.bind(this)
            );
        },

        _createItemPriceSingle: function (compare_price, original_price, final_price, $priceTemplate) {
            if (original_price !== final_price) {
                var $discountedPrice = $(
                    selectors.cartItemDiscountedPriceGroup,
                    $priceTemplate
                ).clone();

                $(selectors.cartItemOriginalPrice, $discountedPrice).html(
                    theme.Currency.formatMoney(original_price, theme.moneyFormat)
                );
                $(selectors.cartItemFinalPrice, $discountedPrice).html(
                    theme.Currency.formatMoney(final_price, theme.moneyFormat)
                );
                $discountedPrice.removeClass(classes.hide);

                return $discountedPrice[0];
            } else {
                var $regularPrice = $(
                    selectors.cartItemRegularPriceGroup,
                    $priceTemplate
                ).clone();


                $(selectors.cartItemComparePrice, $regularPrice).html(
                    theme.Currency.formatMoney(compare_price, theme.moneyFormat)
                );

                $(selectors.cartItemRegularPrice, $regularPrice).html(
                    theme.Currency.formatMoney(original_price, theme.moneyFormat)
                );

                $regularPrice.removeClass(classes.hide);

                return $regularPrice[0];
            }


        },
        _createItemPriceLine: function (compare_price, original_price, final_price, $priceTemplate) {
            if (original_price !== final_price) {
                var $discountedPrice = $(
                    selectors.cartItemDiscountedPriceGroup,
                    $priceTemplate
                ).clone();

                $(selectors.cartItemOriginalPrice, $discountedPrice).html(
                    theme.Currency.formatMoney(original_price, theme.moneyFormat)
                );
                $(selectors.cartItemFinalPrice, $discountedPrice).html(
                    theme.Currency.formatMoney(final_price, theme.moneyFormat)
                );
                $discountedPrice.removeClass(classes.hide);

                return $discountedPrice[0];
            } else {
                var $regularPrice = $(
                    selectors.cartItemRegularPriceGroup,
                    $priceTemplate
                ).clone();


                $(selectors.cartItemComparePriceLine, $regularPrice).html(
                    theme.Currency.formatMoney(compare_price, theme.moneyFormat)
                );

                $(selectors.cartItemRegularPrice, $regularPrice).html(
                    theme.Currency.formatMoney(original_price, theme.moneyFormat)
                );

                $regularPrice.removeClass(classes.hide);

                return $regularPrice[0];
            }


        },

        _createUnitPrice: function (
            unitPrice,
            unitPriceMeasurement,
            $itemPriceGroup
        ) {
            var $unitPriceGroup = $(
                selectors.unitPriceGroup,
                $itemPriceGroup
            ).clone();

            var unitPriceBaseUnit =
                (unitPriceMeasurement.reference_value !== 1
                    ? unitPriceMeasurement.reference_value
                    : '') + unitPriceMeasurement.reference_unit;

            $(selectors.unitPriceBaseUnit, $unitPriceGroup).text(unitPriceBaseUnit);
            $(selectors.unitPrice, $unitPriceGroup).html(
                theme.Currency.formatMoney(unitPrice, theme.moneyFormat)
            );

            $unitPriceGroup.removeClass(classes.hide);

            return $unitPriceGroup[0];
        },

        _createItemDiscountList: function (item) {
            return $.map(
                item.line_level_discount_allocations,
                function (discount) {
                    var $discount = this.$itemDiscountTemplate.clone();
                    $discount
                        .find(selectors.cartItemDiscountTitle)
                        .text(discount.discount_application.title);
                    $discount
                        .find(selectors.cartItemDiscountAmount)
                        .html(
                            theme.Currency.formatMoney(discount.amount, theme.moneyFormat)
                        );
                    return $discount[0];
                }.bind(this)
            );
        },

        _showQuantityErrorMessages: function (itemElement) {
            $(selectors.cartQuantityErrorMessage, itemElement).text(
                theme.strings.quantityMinimumMessage
            );

            $(selectors.cartQuantityErrorMessageWrapper, itemElement).removeClass(
                classes.hide
            );

            $(selectors.inputQty, itemElement)
                .addClass(classes.inputError)
                .focus();
        },

        _hideQuantityErrorMessage: function () {
            var $errorMessages = $(
                selectors.cartQuantityErrorMessageWrapper
            ).addClass(classes.hide);

            $(selectors.cartQuantityErrorMessage, $errorMessages).text('');

            $(selectors.inputQty, this.$container).removeClass(classes.inputError);
        },

        _handleThumbnailClick: function (evt) {
            var url = $(evt.target)
                .closest(selectors.cartItem)
                .data('cart-item-url');

            window.location.href = url;
        },

        _onNoteChange: function (evt) {
            var note = evt.currentTarget.value;
            this._hideCartError();
            this._hideQuantityErrorMessage();

            var params = {
                url: '/cart/update.js',
                data: { note: note },
                dataType: 'json'
            };

            $.post(params).fail(
                function () {
                    this._showCartError(evt.currentTarget);
                }.bind(this)
            );
        },

        _showCartError: function (elementToFocus) {
            $(selectors.cartErrorMessage).text(theme.strings.cartError);

            $(selectors.cartErrorMessageWrapper).removeClass(classes.hide);

            elementToFocus.focus();
        },

        _hideCartError: function () {
            $(selectors.cartErrorMessageWrapper).addClass(classes.hide);
            $(selectors.cartErrorMessage).text('');
        },

        _onRemoveItem: function (evt) {
            evt.preventDefault();
            var $remove = $(evt.target);
            var $lineItem = $remove.closest(selectors.cartItem);
            var index = $lineItem.attr(attributes.cartItemIndex);
            this._hideCartError();
            removedItemIndex = index;
            bRemoved = true;

            var params = {
                url: '/cart/change.js',
                data: { quantity: 0, line: index },
                dataType: 'json'
            };

            $.post(params)
                .done(
                    function (state) {
                        if (state.item_count === 0) {
                            this._emptyCart();
                        } else {
                            this._createCart(state);
                            this._updateCartUpsellCarousel(state);
                            this._showRemoveMessage($lineItem.clone());
                        }

                        this._setCartCountBubble(state.item_count);
                    }.bind(this)
                )
                .fail(
                    function () {
                        this._showCartError(null);
                    }.bind(this)
                );
        },

        _showRemoveMessage: function (lineItem) {
            var index = lineItem.data('cart-item-index');
            var removeMessage = this._getRemoveMessage(lineItem);
            var $lineItemAtIndex;

            if (index - 1 === 0) {
                $lineItemAtIndex = $('[data-cart-item-index="1"]', this.$container);
                $(removeMessage).insertBefore($lineItemAtIndex);
            } else {
                $lineItemAtIndex = $(
                    '[data-cart-item-index="' + (index - 1) + '"]',
                    this.$container
                );
                removeMessage.insertAfter($lineItemAtIndex);
            }
            removeMessage.focus();
        },

        _getRemoveMessage: function (lineItem) {
            var formattedMessage = this._formatRemoveMessage(lineItem);

            var $tableCell = $(selectors.cartTableCell, lineItem).clone();
            $tableCell
                .removeClass()
                .addClass(classes.cartRemovedProduct)
                .attr('colspan', '4')
                .html(formattedMessage);

            lineItem
                .attr('role', 'alert')
                .html($tableCell)
                .attr('tabindex', '-1');

            return lineItem;
        },

        _formatRemoveMessage: function (lineItem) {
            var quantity = lineItem.data('cart-item-quantity');
            var url = lineItem.attr(attributes.cartItemUrl);
            var title = lineItem.attr(attributes.cartItemTitle);

            return theme.strings.removedItemMessage
                .replace('[quantity]', quantity)
                .replace(
                    '[link]',
                    '<a ' +
                    'href="' +
                    url +
                    '" class="text-link text-link--accent">' +
                    title +
                    '</a>'
                );
        },

        _setCartCountBubble: function (quantity) {
            this.$cartCountBubble =
                this.$cartCountBubble || $(selectors.cartCountBubble);
            this.$cartCount = this.$cartCount || $(selectors.cartCount);

            if (quantity > 0) {
                this.$cartCountBubble.removeClass(classes.hide);
                this.$cartCount.html(quantity);
            } else {
                this.$cartCountBubble.addClass(classes.hide);
                this.$cartCount.html('');
            }
        },

        _emptyCart: function () {
            this.$emptyPageContent =
                this.$emptyPageContent ||
                $(selectors.emptyPageContent, this.$container);
            this.$cartWrapper =
                this.$cartWrapper || $(selectors.cartWrapper, this.$container);

            this.$emptyPageContent.removeClass(classes.hide);
            this.$cartWrapper.addClass(classes.hide);
        },

        cookiesEnabled: function () {
            var cookieEnabled = navigator.cookieEnabled;

            if (!cookieEnabled) {
                document.cookie = 'testcookie';
                cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
            }
            return cookieEnabled;
        }
    });

    return Cart;
})();